import { render, staticRenderFns } from "./Select-perfis.vue?vue&type=template&id=5eb0e3ed&"
import script from "./Select-perfis.vue?vue&type=script&lang=js&"
export * from "./Select-perfis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports